import { Button, Typography } from '@material-ui/core'
import * as Assert from 'assert'
import * as React from 'react'

import { submitGameAnswers } from '../../services/game-services'
import { taskStyles } from '../../styles/TaskStyles'
import { formatSeconds, invoke } from '../../utils/helper'
import { StartedGameDto } from '../../utils/types'
import { ContinueButton } from '../atoms/ContinueButton'
import { VideoPlayer } from '../molecules/VideoPlayer'

interface Props {
    secondsLeft: number
    puzzleIndex: number
    game: StartedGameDto
    canValidate: boolean
    answers: string[]
    onValidate(result: (boolean | undefined)[]): void
    onComplete(): void
    onReset(): void
}

export const GamePuzzleTemplate: React.FC<Props> = ({
    puzzleIndex, game, onComplete, onReset, secondsLeft,
    canValidate, answers, onValidate, children
}) => {
    const gamePuzzle = game.puzzles[puzzleIndex]
    const puzzle = game.escapeRoom.puzzles[puzzleIndex]

    Assert.ok(puzzle)
    Assert.ok(gamePuzzle)
    Assert.ok(gamePuzzle.puzzleId === puzzle.puzzleId)

    const styles = taskStyles()
    const canComplete = answers.every((a) => a.length > 0) && canValidate

    const validateAnswers = async () => {
        const updatedPuzzle = await invoke(async () => {
            return submitGameAnswers(game.gameId, puzzle.puzzleId, {
                answers
            })
        }, {
            operation: 'Validerer'
        })

        onValidate(
            updatedPuzzle.tasks.map((t) => t.correct)
        )

        if (updatedPuzzle.finishedAt) {
            onComplete()
        }
    }

    let timerColor = '#008000'
    if (secondsLeft < 60 || secondsLeft === 0) {
        timerColor = 'red'
    } else if (secondsLeft < 60 * 5) {
        timerColor = 'orange'
    }

    return (
        <>
            <div className={styles.gameOverBtnContainer}>
                <Button
                    variant="contained"
                    className={styles.gameOverBtn}
                    onClick={onReset}>
                    Afslut tidsrejsen
                </Button>
            </div>

            <VideoPlayer videoUri={puzzle.videoUri}/>

            {children}

            <div className={styles.containerTimer}>
                <Typography className={styles.timeText} variant="h5">
                    I har
                    <span className={styles.timerSpan} style={{ backgroundColor: timerColor }}>
                        {formatSeconds(secondsLeft)}
                    </span>tilbage!
                </Typography>

            </div>

            <ContinueButton
                title="NÆSTE"
                disabled={!canComplete}
                onClick={validateAnswers}/>
        </>
    )
}
